import Grid from '@mui/material/Grid';
import { WELL_GUARDIAN_PATHS } from 'constants/paths';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { matchPath, useLocation } from 'react-router-dom';

import styles from './BasicHeader.module.scss';

const BasicHeader: React.FunctionComponent = () => {
  const { pathname } = useLocation();
  const intl = useIntl();

  const pageKey = useMemo(
    () =>
      Object.keys(WELL_GUARDIAN_PATHS).find(
        key => !!matchPath(WELL_GUARDIAN_PATHS[key as keyof typeof WELL_GUARDIAN_PATHS], pathname),
      ),
    [pathname],
  );

  return (
    <Grid direction="row" className={styles.pageTitle} data-testid={`basic-header-${pageKey}`}>
      <h1>{intl.formatMessage({ id: `header.pages.${pageKey}` })}</h1>
    </Grid>
  );
};

export default BasicHeader;
